const Theme = {
  colors: {
    BrandOrange: '#ED8B00',
    BrandBlue: '#3A499C',
    DarkGrey: '#323840',
    MidGrey: '#70747A',
    BrightGreen: '#14DE46',
    LightBlue: '#4183D1',
    Black: "#000000",
    White: '#FFFFFF',
  },
  devices: {
    mobile: "500px",
    tablet: "1000px",
  }
}

export default Theme;